var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgConvert = function SvgConvert(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.06 15.94L16 18L16.94 15.94L19 15L16.94 14.06L16 12L15.06 14.06L13 15L15.06 15.94ZM3 15L5.06 14.06L6 12L6.94 14.06L9 15L6.94 15.94L6 18L5.06 15.94L3 15ZM11.63 18.63L11 20L10.37 18.63L9 18L10.37 17.37L11 16L11.63 17.37L13 18L11.63 18.63ZM12 11C15.09 11 17.94 9.62 20 7.56V11H22V4H15V6H18.72C16.98 7.8 14.52 9 12 9C8.68 9 5.64 6.9 4.18 4L2 4C3.59 8.09 7.65 11 12 11Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgConvert);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTUuMDYgMTUuOTRMMTYgMThMMTYuOTQgMTUuOTRMMTkgMTVMMTYuOTQgMTQuMDZMMTYgMTJMMTUuMDYgMTQuMDZMMTMgMTVMMTUuMDYgMTUuOTRaTTMgMTVMNS4wNiAxNC4wNkw2IDEyTDYuOTQgMTQuMDZMOSAxNUw2Ljk0IDE1Ljk0TDYgMThMNS4wNiAxNS45NEwzIDE1Wk0xMS42MyAxOC42M0wxMSAyMEwxMC4zNyAxOC42M0w5IDE4TDEwLjM3IDE3LjM3TDExIDE2TDExLjYzIDE3LjM3TDEzIDE4TDExLjYzIDE4LjYzWk0xMiAxMUMxNS4wOSAxMSAxNy45NCA5LjYyIDIwIDcuNTZWMTFIMjJWNEgxNVY2SDE4LjcyQzE2Ljk4IDcuOCAxNC41MiA5IDEyIDlDOC42OCA5IDUuNjQgNi45IDQuMTggNEwyIDRDMy41OSA4LjA5IDcuNjUgMTEgMTIgMTFaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";